import React from "react"
import cx from "classnames"
import SlIcon from "@shoelace-style/shoelace/dist/react/icon/index"

const Icon = ({className, name, label, size = "text-xl"}) => <SlIcon className={cx(className, size)} name={name} label={label} />

export default Icon
